export function getListItems() {
  const urlDetails = [
    {
      iconName: 'Health Assessment',
      label: 'Health Assessment',
    },
    {
      iconName: 'Facebook',
      label: 'Facebook',
    },
    {
      iconName: 'Instagram',
      label: 'Instagram',
    },
    {
      iconName: 'Twitter',
      label: 'Twitter',
    },
    {
      iconName: 'General',
      label: 'General',
    },
  ];
  return urlDetails;
}
export const IconNameByType = {
  ['Health Assessment']: 'Health-Assessment',
  ['Facebook']: 'Facebook',
  ['Instagram']: 'Instagram',
  ['Twitter']: 'Twitter',
  ['General']: 'General',
};
